export const LTL_CONFIG = (lang) => {
	if (lang === 'de') {
		return 'Plano Personalizado de Alemão';
	}

	if (lang === 'es') {
		return 'Plano Personalizado de Espanhol';
	}

	if (lang === 'it') {
		return 'Plano Personalizado de Italiano';
	}

	if (lang === 'fr') {
		return 'Plano Personalizado de Francês';
	}

	return 'Plano Personalizado de Inglês';
};
